/**
 * eventBus事件命名规范
 * 文件名_方法名_组件标识
 * PS: 组件标识可以为空字符串
 */

import Vue from 'vue'
export default new Vue()



// WEBPACK FOOTER //
// ./src/config/eventBus.js